<template>
  <v-menu :nudge-width="210" offset-y>
    <template v-slot:activator="{ on }">
      <v-list-item v-on="on" color="grey" v-if="profile">
        <v-avatar class="profile text-center" size="30">
          <v-img :src="getProfilePic()" alt="profile" />
        </v-avatar>
      </v-list-item>
    </template>
    <v-card class="profile-menu">
      <v-list>
        <v-list-item class="text-center">
          <v-list-item-content v-if="profile && profile.profile_image !== null">
            <v-avatar class="profile text-center" size="80">
              <v-img
                :src="
                  profile.employer && profile.employer.profile_image
                    ? profile.employer.profile_image
                    : defaultImage
                "
                :alt="profile.name"
                title="Profile"
              />
            </v-avatar>
          </v-list-item-content>
          <v-list-item-content v-else>
            <v-avatar
              v-if="profile && profile.name"
              size="80"
              :color="getProfileColor(profile.name[0])"
            >
              <span v-if="profile" class="text-uppercase white--text"
                >{{ profile.name[0] }}{{ profile.name[1] }}</span
              >
            </v-avatar>
          </v-list-item-content>
        </v-list-item>
        <v-list-item class="text-center" v-if="profile && profile.name">
          <v-list-item-content v-if="profile">
            <small class="text-capitalize">{{ getRole() }}</small>
            <v-list-item-title v-if="profile && profile.name">
              <h4>{{ profile.name }}</h4>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-spacer />
          <div>
            <v-btn
              rounded
              outlined
              x-small
              class="primary"
              dark
              @click="switchRole"
              >Change Role</v-btn
            >
          </div>
          <v-spacer />
        </v-list-item>
        <v-list-item>
          <v-spacer />
          <div>
            <v-btn rounded outlined small color="#666" :to="'/profile'"
              >Manage your account</v-btn
            >
          </div>
          <v-spacer />
        </v-list-item>
      </v-list>
      <v-divider></v-divider>
      <v-card-actions class="ma-2">
        <v-spacer />
        <v-btn @click="logout()" class="blue" block outlined dark
          >Sign out</v-btn
        >
        <v-spacer />
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");
import { filters } from "../../utility/filters";

export default {
  data() {
    return {
      defaultImage: require("@/assets/img/avatar.svg"),
    };
  },

  computed: {
    ...mapGetters({
      loading: "loading",
      profile: "profile",
      role: "getRole",
    }),
  },

  watch: {
    role() {
      this.getRole();
    },
  },

  methods: {
    switchRole() {
      // localStorage.removeItem('myArrayKey');
      this.$router.push("/switch-role");
    },
    logout: function() {
      this.$store.dispatch("auth/destroyToken").then((response) => {
        if (response) {
          this.$router.push("/login");
        }
      });
    },
    getProfileColor(letter) {
      return filters.getProfileColor(letter);
    },

    getRole() {
      return this.role;
    },

    getProfilePic() {
      if (
        this.profile &&
        this.profile.employer &&
        this.profile.employer.profile_image
      ) {
        return this.profile.employer.profile_image;
      } else {
        return this.defaultImage;
      }
    },
  },
};
</script>
